import { useCallback, useEffect, useState } from 'react';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Autocomplete, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Skeleton, TextField, Typography } from '@mui/material';

import { GlobalVariables } from '../../../globalVar';
import customAxios from '../../../utils/customAxios';
import { getToast } from '../../../utils/toastConfig';

const HEADERS = { headers: { Authorization: 'bearer ' + localStorage.getItem('token') } };

export const UpdateModelModal = ({ modelId, showModal, setShowModal, refreshData }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [name, setName] = useState('');
  const [brands, setBrands] = useState([]);
  const [brand, setBrand] = useState(null);

  const fetchData = useCallback(async () => {
    setIsFetching(true);
    try {
      const [modelResponse, brandsResponse] = await Promise.all([
        customAxios.get(`${GlobalVariables.getURL()}models/${modelId}`, HEADERS),
        customAxios.get(`${GlobalVariables.getURL()}brands/`, HEADERS),
      ]);
      const model = modelResponse.data.data || modelResponse.data;
      const loadedBrands = brandsResponse.data.data || brandsResponse.data || [];
      setName(model?.name || '');
      setBrands(loadedBrands);
      setBrand(loadedBrands.find((item) => item.id === model?.brand_id) || null);
    } catch (error) {
      console.log('Error fetching model:', error);
      getToast({ status: 'error', title: error.response?.data?.message || 'Error' });
    } finally {
      setIsFetching(false);
    }
  }, [modelId]);
  useEffect(() => {
    if (showModal && modelId) fetchData();
  }, [showModal, modelId, fetchData]);
  const handleClose = () => {
    setShowModal(false);
    setName('');
    setBrand(null);
    refreshData();
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const response = await customAxios.patch(`${GlobalVariables.getURL()}models/${modelId}`, { name, brand_id: brand.id }, HEADERS);
      if (response.status >= 200 && response.status < 300) {
        getToast({ status: 'success', title: 'Modelo actualizado exitosamente en la base de datos.' });
        handleClose();
      }
    } catch (error) {
      console.log('Error updating model:', error);
      getToast({ status: 'error', title: error.response?.data?.message || 'Error' });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={showModal} maxWidth='sm' fullWidth onClose={handleClose}>
      <DialogTitle><Typography className='inventory-movmodal-title'>Editar modelo</Typography></DialogTitle>
      <IconButton aria-label='close' onClick={handleClose} sx={{ position: 'absolute', right: 20, top: 20, width: 40, height: 40 }}><FontAwesomeIcon icon={faTimes} /></IconButton>
      <DialogContent dividers>
        <form id='update-model-form' onSubmit={handleSubmit}>
          {isFetching ? <><Skeleton variant='rectangular' width='100%' height={56} sx={{ mb: 2 }} /><Skeleton variant='rectangular' width='100%' height={56} /></> : <>
            <TextField required fullWidth disabled={isLoading} label='Nombre' placeholder='Nombre...' value={name} onChange={(event) => setName(event.target.value)} sx={{ mb: 2 }} />
            <Autocomplete options={brands} value={brand} disabled={isLoading} isOptionEqualToValue={(option, value) => option.id === value.id} getOptionLabel={(option) => option.name || ''} onChange={(event, value) => setBrand(value)} renderInput={(params) => <TextField {...params} required label='Marca' placeholder='Marca...' />} />
          </>}
        </form>
      </DialogContent>
      <DialogActions><Button variant='contained' form='update-model-form' type='submit' disabled={isLoading || isFetching || !brand}>{isLoading ? <CircularProgress size='2rem' /> : <Typography>Guardar</Typography>}</Button></DialogActions>
    </Dialog>
  );
};